module.exports = __webpack_public_path__ + "public/images/curated-hero-section-blob.a0ec93c36fc10ea36bff0dadd33556d8.png";